



// 



import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';

import { Subject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { ApiService } from '../../../services/api.service';
import { AuthService } from '../../../services/auth.service';
import { Member } from '../../../models/member.model';
import { User } from '../../../models/user.model';
import { Group } from '../../../models/group.model';
import { FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { Product } from '../../../models/product.model';
import { SnotifyService } from 'ng-snotify';

@Component({
    selector: 'new-member',
    template: require('./new-member.component.html'),
    styles: [require('./new-member.component.css')],
})
export class NewMemberComponent {
    currentUser: User;
    memberIdError = "";
    groups: Group[];
    products: Product[];
    memberTypes: any[];
    states = [];

    newMember: Member = {
        memberTypeId : -1,
        memberPolicies: [{
            formControl: new FormControl(),
            policyNumberError: "",
            activeDate: new Date()
        }]
     } as any;

    memberId = new FormControl();

    private subject: Subject<string> = new Subject();


    constructor(private router: Router, private apiService: ApiService, private authService: AuthService,
        public dialog: MatDialog, private snotifyService: SnotifyService) {
        this.currentUser = this.authService.currentUser;

        this.getMemberTypes();
        this.getGroups();
        this.getProducts();
        Observable.of(require("../../../assets/data/states_titlecase.json")).subscribe(r => {
            this.states = r;
        });
    }

    getMemberTypes() {
        this.apiService.getMemberTypes().subscribe(r => {
            this.memberTypes = r;
        })
    }

    getGroups() {
        this.apiService.getGroups().subscribe(r => {
            this.groups = r;
        })
    }

    getProducts() {
        this.apiService.getProducts().subscribe(r => {
            this.products = r;
        })
    }

    getRowClass(row) {
        return {
            'clickable': true
        };
    }

    checkMemberId(ev) {
        console.log(ev)
        if (!this.newMember.memberId) {
            this.memberIdError = "Member Id is required!"
        }
        this.apiService.isExistingMember(this.newMember.memberId).subscribe(r => {
            console.log(r)
            if (r) {
                console.log(r)
        
                this.memberId.setErrors({ 'invalid': true });
                this.memberIdError = "Member Id Existed";
            }
    
        })
    }

    checkPolicyNumber(p) {
        if (!p.policyNumber) {
            p.errorMsg = "policyNumber is required!"
        }
        this.apiService.isExistingPolicyNumber(p.policyNumber).subscribe(r => {
            console.log(r)
            if (r) {
                p.formControl.setErrors({ 'invalid': true });
                p.policyNumberError = "Policy Number Existed";
            }

        })
    }

    addPolicy() {
        this.newMember.memberPolicies.push({ formControl: new FormControl(), activeDate: new Date()});
    }

    removePolicy() {
        this.newMember.memberPolicies.pop();
    }

    createMember() {

        var member = _.cloneDeep(this.newMember);
        _.each(member.memberPolicies, mp => {
            delete mp.formControl;
            mp.groupId = this.newMember.groupId;
        })
        console.log(member)
        this.apiService.createMember(member).subscribe(r => {
            this.snotifyService.success("Create New Member Successfully!");
            this.newMember = {
                memberTypeId: -1,
                memberPolicies: [{
                    formControl: new FormControl(),
                    policyNumberError: ""
                }]
            } as any;
        })
    }

    checkInvalid() {
        return this.memberId.invalid ||
            _.some(this.newMember.memberPolicies, i => {
                return i.formControl.invalid || !i.productId;
            }) ||
            !this.newMember.groupId ||
            !this.newMember.firstName ||
            !this.newMember.firstName ||
            !this.newMember.zipcode ||
            !this.newMember.email ||
            this.newMember.memberTypeId < 0 ||
            !this.newMember.dob
    
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/members/new-member/new-member.component.ts